import { useSelector } from 'react-redux';

import { isFetchingMarketingCampaignsSelector } from '@/domains/productDiscovery/CommercialAnimation/commercialAnimation.selectors';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

export const useIsFetchingMarketingCampaigns = () =>
  useSelector<SpartacuxProductDiscoveryDomainState, boolean>(
    isFetchingMarketingCampaignsSelector,
  );
